var app = angular.module("leonardo");

var AcceptInvitationDialog = function($scope, NotificationService) {
  $scope.account = $scope.ngDialogData.invitation.from_account.name;
  $scope.submit = function() {
    $scope.ngDialogData.invitation.accept().then(function(){
      NotificationService.notify('success', 'We are linking the property data and templates in your account. This can take up to 20 minutes to complete.');
      $scope.confirm();
    });
  };
};

app.controller('AcceptInvitationDialog', ['$scope', 'NotificationService', AcceptInvitationDialog]);
